import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import Dropzone from 'dropzone';

import 'dropzone/dist/dropzone.css';

export default class extends Controller {
  connect() {
    const options = {
      maxFiles: 1,
      dictDefaultMessage: 'Choose or Drop a file here',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
      },
      ...JSON.parse(this.element.dataset.options),
    };

    const dz = new Dropzone(`#${this.element.id}`, options);
    dz.on('success', (file, response) => {
      if (response.success) {
        Turbo.visit(response.redirect_url);
      }
    });
  }
}
